import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamilySans, fontFamily } from "@clockwise/web-commons/src/styles/type.styles";

export const header: CSSProperties = {
  fontFamily,
  fontSize: "24px",
  lineHeight: "39px",
  fontWeight: "bold",
  color: colors.blueDusk.standard,
  marginBottom: 14,
  "&.extra-margin": {
    marginBottom: 20,
  },
  "&.pre-extra-margin": {
    marginTop: 20,
  },
};

export const subHeader: CSSProperties = {
  ...header,
  fontSize: "18px",
  lineHeight: "29px",
};

export const preHeader: CSSProperties = {
  fontFamily: fontFamilySans,
  fontSize: "16px",
  lineHeight: "36px",
  color: greys.slate,
  marginBottom: 26,
};

export const body: CSSProperties = {
  fontFamily: fontFamilySans,
  fontSize: "16px",
  lineHeight: "24px",
  color: greys.slate,
  "&.extra-margin": {
    marginBottom: 24,
  },
};

export const subtitle: CSSProperties = {
  fontFamily: fontFamilySans,
  fontSize: "14px",
  lineHeight: "21px",
  color: greys.slate,
  marginBottom: 30,
};

export const paper: CSSProperties = {
  maxWidth: 1200,
  maxHeight: 800,
  minWidth: 1200,
  minHeight: 700,
  width: "calc(100% - 80px)",
  height: "calc(100% - 80px)",
  borderRadius: 10,
  top: "50%",
  transform: "translateY(calc(-50% - 32px))",
  margin: 32,
  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
};

export const scrollBody: CSSProperties = {
  overflowX: "auto",
  "&::after": {
    height: "unset",
  },
};

export const basicPaper: CSSProperties = {
  borderRadius: 10,
  maxWidth: 805,
  width: "100%",
};

export const banner: CSSProperties = {
  position: "absolute",
  color: greys.white,
  background: colors.blueDusk.lighter,
  padding: "30px 20px",
  fontFamily: fontFamilySans,
  fontSize: "16px",
  transition: "opacity 1s, left 1s",
  opacity: 0,
  width: "100%",
  left: "100%",
  top: 70,
};

export const navPane: CSSProperties = {
  position: "relative",
  height: 70,

  "& > .nav-absolute": {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 3,
    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "0 40px",

    "& > .nav-items": {
      flex: 1,
      userSelect: "none",
      display: "flex",
      flexDirection: "row",
      height: "100%",
      alignItems: "center",

      "& > .logo-wrapper": {
        marginRight: 24,
      },

      "& > .close-icon": {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        flex: 1,
        textAlign: "right",

        "& .icon": {
          color: greys.blueGrey,
          width: 24,
          height: 24,
        },

        "& .label": {
          marginLeft: 9,
          color: greys.blueGrey,
          fontSize: "16px",
        },
      },

      "& > .nav-chevron": {
        color: greys.cloudyBlue,
        width: 24,
        height: 24,
        margin: "0 15px",
      },

      "& > .nav-item": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        height: "100%",
        fontFamily: fontFamilySans,
        fontWeight: "bold",
        fontSize: "17px",
        lineHeight: "20px",
        color: greys.slate,

        "&.active": {
          color: colors.blueDusk.standard,
          borderBottom: `3px solid ${colors.blueDusk.darker}`,
        },
        "&.disabled": {
          cursor: "not-allowed",
          color: greys.cloudyBlue,
        },
      },
    },
  },
};

export const styles = {
  basicPaper,
  paper,
  banner,
  scrollBody,
  logo: {
    width: 138,
  } as CSSProperties,
  hours: {
    background: "transparent",
    position: "relative",
    marginTop: 30,
    height: "calc(100% - 30px)",
    width: 20,
    borderRight: "1px solid #ccc",
    "& > .hour": {
      position: "absolute",
      fontFamily: fontFamilySans,
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "10px",
      lineHeight: "12px",

      color: "#96ACC0",
    },
  } as CSSProperties,
  container: {
    position: "relative",
    overflow: "hidden",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    transformOrigin: "right bottom",
    width: "100%",
    height: "100%",
    "& > .nav-pane": navPane,
    "& > .content-pane": {
      display: "flex",
      flexDirection: "row",
      flex: 1,
      overflowY: "auto",
    },
  } as CSSProperties,
  buttonForward: {
    flex: 1,
    borderRadius: 0,
    boxShadow: "none",
    backgroundColor: colors.blueDusk.standard,
    color: greys.white,
    padding: 26,

    "&:hover": {
      backgroundColor: colors.blueDusk.darker,
    },
  } as CSSProperties,
  buttonBack: {
    flex: 1,
    borderRadius: 0,
    boxShadow: "none",
    backgroundColor: colors.blueCool.lighter,
    color: greys.white,
    padding: 26,

    "&:hover": {
      backgroundColor: colors.blueCool.standard,
    },
  } as CSSProperties,
  buttonLabel: {
    justifyContent: "left",
    alignItems: "left",
    textAlign: "left",
  } as CSSProperties,
  workingDay: {
    userSelect: "none",
    cursor: "pointer",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    width: 24,
    height: 24,
    borderRadius: "50%",
    fontSize: 14,
    marginRight: 8,
    color: greys.slate,
    border: `1px solid ${greys.slate}`,

    "&.active": {
      color: greys.white,
      backgroundColor: colors.blueDusk.darker,
      border: "none",
    },

    "&:last-child": {
      marginRight: 0,
    },
  } as CSSProperties,
  workingHours: {
    marginTop: 24,
    display: "flex",
    flexDirection: "row",

    "& > .label": {
      width: 115,
      paddingTop: 22,
      fontFamily: fontFamilySans,
      color: colors.blueDusk.standard,
      fontWeight: "bold",
    },

    "& .control": {
      marginLeft: 8,
    },
  } as CSSProperties,
  loader: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 510,
  } as CSSProperties,
  fixed: {
    position: "fixed",
    display: "flex",
    backgroundColor: greys.paleGrey,
    overflow: "auto",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    "& > .inner-container": {
      maxWidth: 1200,
      maxHeight: 800,
      minWidth: 1200,
      minHeight: 700,
      borderRadius: 10,
      overflow: "hidden",
      margin: "auto",
      width: "100%",
      height: "100%",
    },
  } as CSSProperties,
  fixedBasic: {
    "& > div": {
      borderRadius: 10,
    },
  } as CSSProperties,
};
